import React, {Component} from 'react'
import PropTypes from "prop-types";



class RequestOtherMedicalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,

        }
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }



    render() {
        let {t,requestFromVisit} = this.props
        let {entry} = this.state

        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Psychiatric_diagnosis')}?</label>
                            {/*
                            <Error isShown={!!(this.props.errors)['Psychiatric_diagnosis']} errorMessage={(this.props.errors)['Psychiatric_diagnosis']}/>
*/}
                        </div>

                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.Psychiatric_diagnosis==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={() => this.props.onYesNoValueChange("Psychiatric_diagnosis","Yes")}>{t('patient_boarding.yes')}</button>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.Psychiatric_diagnosis==="No"? 'inputBoxStyle-yes-no-middle-selected' :'inputBoxStyle-yes-no-middle'}
                                onClick={() => this.props.onYesNoValueChange("Psychiatric_diagnosis","No")}>{t('patient_boarding.no')}</button>
                        <button disabled={requestFromVisit} tabIndex={0} className={entry.Psychiatric_diagnosis==="Unknown"?  'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={() => this.props.onYesNoValueChange("Psychiatric_diagnosis","Unknown")}>{t('patient_boarding.Unknown')}</button>
                    </div>
                </div>

                <div className={'patientsFormRow'}>

                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Nuclear_family_psychosis')}?</label>
                            {/*
                            <Error isShown={!!(this.props.errors)['Nuclear_family_psychosis']} errorMessage={(this.props.errors)['Nuclear_family_psychosis']}/>
*/}
                        </div>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.Nuclear_family_psychosis==="Yes"?'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={() => this.props.onYesNoValueChange("Nuclear_family_psychosis", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.Nuclear_family_psychosis==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={() => this.props.onYesNoValueChange("Nuclear_family_psychosis", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>

                </div>


                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Drug_abuse')}?</label>
                        </div>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.Drug_abuse==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={() => this.props.onYesNoValueChange("Drug_abuse", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.Drug_abuse==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={() => this.props.onYesNoValueChange("Drug_abuse", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.SuffersDiabetes')}?</label>
                        </div>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.SuffersDiabetes==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={() => this.props.onYesNoValueChange("SuffersDiabetes", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.SuffersDiabetes==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={() => this.props.onYesNoValueChange("SuffersDiabetes", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.SuffersBloodPressure')}?</label>
                        </div>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.SuffersBloodPressure==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={() => this.props.onYesNoValueChange("SuffersBloodPressure", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button disabled={requestFromVisit} tabIndex={0}  className={entry.SuffersBloodPressure==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={() => this.props.onYesNoValueChange("SuffersBloodPressure", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

            </div>

        )
    }
}

RequestOtherMedicalInfo.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default RequestOtherMedicalInfo;
